
class PSUIPlugin
{
	constructor(Grape)
	{
		this.Grape = Grape;

		if (window)
			window.PSUIPlugin = this;
		//	window.grape.themes = this;
	}

	async onInit()
	{
	}

	async onLoad()
	{
	}


	async onSessionChange(session)
	{
	}
}

export default PSUIPlugin;

